exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".openCardListTile[data-v-c0dbed12]{height:auto;white-space:normal;overflow:visible}.provider-span[data-v-c0dbed12]{text-align:center;padding-left:12px;font-style:italic;color:#725f5f}", ""]);

// exports
